export default "__VITE_PUBLIC_ASSET__a0bec825__"